import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MuiDivider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import type { Theme } from '@mui/material/styles';

export const CartItemCardWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  border: `1.5px solid ${theme.novus.cartItemBorder}`,
  borderRadius: '10px',
  overflow: 'hidden',
}));

export const ActionLinksRow = styled(Box)({
  display: 'flex',
  gap: '30px',
  paddingLeft: '20px',
  paddingRight: '20px',
});

export const ExpandableFooter = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  padding: '10px 15px',
  backgroundColor: theme.novus.cartExpandableBg,
  marginTop: '20px',
}));

export const ExpandButton = styled(Button)<{ theme?: Theme }>(({ theme }) => ({
  color: theme.novus.borderBlack,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  fontFamily: 'Roboto',
  padding: '5px 0',
  minWidth: 'auto',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const PricingCard = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  backgroundColor: theme.novus.cartSurfaceWhite,
  border: `1.5px solid ${theme?.novus?.accentCyanBright ?? '#00CDFF'}`,
  borderRadius: '20px',
  padding: '30px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
}));

export const PricingRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const DiscountText = styled(Typography)<{ theme?: Theme }>(({ theme }) => ({
  color: theme?.novus?.discountGreen ?? '#38780A',
  fontWeight: 600,
  fontSize: '16px',
  fontFamily: 'Roboto',
  textAlign: 'right',
}));

export const TotalDivider = styled(MuiDivider)<{ theme?: Theme }>(({ theme }) => ({
  borderColor: theme?.novus?.orderSummaryDivider ?? '#2FD6FF',
  borderWidth: '1.5px',
}));

export const ItemDivider = styled(MuiDivider)<{ theme?: Theme }>(({ theme }) => ({
  borderColor: theme?.novus?.headerBorder ?? '#DFE4ED',
}));

export const VerticalDivider = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  width: '1px',
  alignSelf: 'stretch',
  backgroundColor: theme.novus.cartVerticalDivider,
}));

export const ExpandableSectionContainer = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  padding: '12px 20px',
  backgroundColor: theme.novus.cartExpandableSectionBg,
}));

